import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { VesselRedundancyGroup } from '../../dto/vessel-redundancy-group';

@Component({
  selector: 'dpi-vessel-redundancy-group-details',
  imports: [MatInputModule, MatFormFieldModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './vessel-redundancy-group-details.component.html',
  styleUrl: './vessel-redundancy-group-details.component.scss'
})
export class VesselRedundancyGroupDetailsComponent {
  readonly dialogRef = inject(MatDialogRef<VesselRedundancyGroupDetailsComponent>);
  redundancyGroup : VesselRedundancyGroup;
  isToUpdate: boolean;
  isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VesselRedundancyGroup) {
    this.redundancyGroup = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }
}
